import { FormattedMessage as FM } from "react-intl";

import { STYLE_ACTION_BUTTON_PRIMARY } from "../constants";

function SaveBar({ saving, onSave }) {
  return (
    <>
      <div className="h-16 tablet:hidden" />
      <div className="fixed inset-x-0 bottom-0 z-20 border-t border-neutral-200 bg-white px-3 py-3 tablet:sticky tablet:inset-x-auto tablet:-mx-3">
        <button
          type="button"
          disabled={saving}
          onClick={onSave}
          className={`${STYLE_ACTION_BUTTON_PRIMARY} min-h-11 w-full disabled:opacity-50`}
        >
          <FM id={saving ? "melhous.dash.list.saving" : "melhous.dash.save"} />
        </button>
      </div>
    </>
  );
}

export default SaveBar;
